import styled from "@emotion/styled";
import { systemWidth } from "@kaltura/mediaspace-shared-styled";
import { Typography } from "@kaltura/ds-react-components";

export const StyledRestreamDestinations = styled("div")(({ theme }) => ({
    "&": systemWidth({ theme }),
}));

export const StyledAddSection = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(2),
    margin: theme.spacing(1, 0, 2),
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));
